import { Cooperative } from './cooperatives';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import * as CodiceFiscale from 'codice-fiscale-js';
import * as IBAN from 'iban';


export const employeeDiscountEndpoint = 'employeeDiscount';

export interface EmployeeDiscount {
  _id: string;
  employee_email: string;
  employee_firstname: string;
  employee_lastname: string;
  employee_cf: string;
  employee_coop: string; 
  subscriber: string;
  customer_firstname: string;
  customer_lastname: string;
  customer_cf: string;
}

export const EdValidators = {
  cf: (control: AbstractControl): {[key: string]: any} => {
    if (CodiceFiscale.check(control.value)) {      
      return null;
    }
    return {'cf' : true};
  },
  sameCf: (control: AbstractControl): {[key: string]: any} => {
    let emp_cf = control.parent.get('cf').value;
    if(control.value !== emp_cf){
      return null;
    }
    return null;
    // return {'customer_cf' : true};
  }
};



// WEBPACK FOOTER //
// ./src/app/models/employee-discount.ts